export default {
  marketOptions: ({ marketTypeDimension, periodDimension, outcomesPerEvent }) => ({
    marketTypeDimension: marketTypeDimension.value,
    periodDimension: periodDimension.value,
    outcomesPerEvent,
  }),
  cardBodyClassNames: () => 'bet-boost-market bet-boost--accas',
};
